// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__3_e7e","blurred":"styles_blurred__U2D7u"};